import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import * as ReportsActions from './reports-store.actions';
import { BaseReportsService } from '../api/reports.service';
import { TableData } from '@shared/ui/tables';
import { BaseUser, DailyReports, DailyReportsResponse, SummaryReports, SummaryReportsResponse } from '../models/reports.models';

@Injectable()
export class ReportsEffect {
  listPaginationDailyReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReportsActions.listPaginationDailyReports),
      switchMap((request) =>
        this.service.fetchDailyReports(request.query).pipe(
          map(
            (response) =>
              new TableData(
                response.value.count,
                response.value.data.map((x) => this.transformDailyReportsResponse(x))
              )
          ),
          map((response) =>
            ReportsActions.listPaginationDailyReportsSuccess({ paginationDailyReports: response.data, query: request.query, filteredDailyReportsTotalCount: response.count })
          ),
          catchError(() => of(ReportsActions.listPaginationDailyReportsFailure()))
        )
      )
    )
  );

  listPaginationSummaryReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReportsActions.listPaginationSummaryReports),
      switchMap((request) =>
        this.service.fetchSummaryReports(request.query).pipe(
          map(
            (response) =>
              new TableData(
                response.value.count,
                response.value.data.map((x) => this.transformFromSummaryReportsResponse(x))
              )
          ),
          map((response) =>
            ReportsActions.listPaginationSummaryReportsSuccess({ paginationSummaryReports: response.data, query: request.query, filteredSummaryReportsTotalCount: response.count })
          ),
          catchError(() => of(ReportsActions.listPaginationSummaryReportsFailure()))
        )
      )
    )
  );

  constructor(private actions$: Actions, private service: BaseReportsService) {}

  private transformDailyReportsResponse(x: DailyReportsResponse): DailyReports {
    return new DailyReports(
      new BaseUser(x.User.FirstName, x.User.LastName, x.User.EmployeeID, x.User.UID, x.User.PictureFullPath),
      x.TotalVideos,
      x.TotalPhotos,
      x.TotalAudios,
      x.TotalDocuments,
      x.TotalOthers,
      x.CreatedOn
    );
  }

  private transformFromSummaryReportsResponse(x: SummaryReportsResponse): SummaryReports {
    return new SummaryReports(
      new BaseUser(x.User.FirstName, x.User.LastName, x.User.EmployeeID, x.User.UID, x.User.PictureFullPath),
      x.TotalVideos,
      x.TotalPhotos,
      x.TotalAudios,
      x.TotalDocuments,
      x.TotalOthers
    );
  }
}
